<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model="queryForm.keyword" placeholder="请输入素材名称/素材ID" clearable @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="queryForm.status" multiple collapse-tags filterable clearable placeholder="选择任务状态" style="width: 180px">
            <el-option v-for="label in stateData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="queryForm.opId" multiple collapse-tags filterable clearable placeholder="选择上传人" style="width: 180px">
            <el-option v-for="label in operatorData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="queryForm.mediaId" multiple collapse-tags filterable clearable placeholder="选择媒体" style="width: 180px">
            <el-option v-for="label in mediaData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select
            v-model="queryForm.adAccountId"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="选择账号"
            style="width: 180px"
          >
            <el-option v-for="label in accountData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select
            v-model="queryForm.imageType"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="选择素材类型"
            style="width: 180px"
          >
            <el-option
              v-for="label in [
                { id: IMAGE_TYPES.IMAGE, name: '图片' },
                { id: IMAGE_TYPES.VIDEO, name: '视频' },
                { id: IMAGE_TYPES.LOGO, name: 'LOGO' },
                { id: IMAGE_TYPES.GROUP_IMAGE, name: '组图' },
                ...EXTRA_IMAGE_TYPES_LIST
              ]"
              :key="label.id"
              :value="label.id"
              :label="label.name"
            ></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select
            v-model="queryForm.toAccountIds"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="被推送账号"
            style="width: 180px"
          >
            <el-option v-for="label in accountData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select v-model="queryForm.source" clearable placeholder="来源" style="width: 180px">
            <el-option v-for="label in UPLOAD_TYPE_LIST" :key="label.value" :value="label.value" :label="label.label"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <DateRangePicker v-model="queryForm.datetime" :clearable="false" style="width: 220px"></DateRangePicker>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script setup>
import { reactive } from 'vue'
import moment from 'moment'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { trim, isArray } from '@/common/js/utils'
import { UPLOAD_TYPE_LIST } from '../const'
import { IMAGE_TYPES } from '../../uploading/consts'
import { EXTRA_IMAGE_TYPES_LIST } from '../hooks/useUpload'
// eslint-disable-next-line
const props = defineProps({
  operatorData: {
    type: Array,
    default: () => []
  },
  accountData: {
    type: Array,
    default: () => []
  },
  stateData: {
    type: Array,
    default: () => []
  }
})
// eslint-disable-next-line
const emit = defineEmits(['on-change'])

const now = moment().format('YYYY-MM-DD')
const start = moment().format('YYYY-MM-01')

const mediaData = [
  { id: 10, name: '巨量引擎' },
  { id: 16, name: '腾讯' },
  { id: 32, name: '磁力引擎' },
  { id: 45, name: '百度信息流' },
  { id: 6, name: '超级汇川' }
]

const queryForm = reactive({
  datetime: [start, now],
  keyword: '',
  imageType: [],
  adAccountId: [],
  opId: [],
  mediaId: [],
  status: [],
  toAccountIds: [],
  source: ''
})

const sendEvent = () => {
  const [begin, end] = queryForm.datetime
  let params = {
    mediaIdStr: isArray(queryForm.mediaId) && queryForm.mediaId.length ? queryForm.mediaId.join(',') : undefined,
    adAccountIdStr: isArray(queryForm.adAccountId) && queryForm.adAccountId.length ? queryForm.adAccountId.join(',') : undefined,
    imgTypesStr: isArray(queryForm.imageType) && queryForm.imageType.length ? queryForm.imageType.join(',') : undefined,
    opIdsStr: isArray(queryForm.opId) && queryForm.opId.length ? queryForm.opId.join(',') : undefined,
    statusStr: isArray(queryForm.status) && queryForm.status.length ? queryForm.status.join(',') : undefined,
    keyword: trim(queryForm.keyword),
    toAccountIds: isArray(queryForm.toAccountIds) && queryForm.toAccountIds.length ? queryForm.toAccountIds : undefined,
    source: queryForm.source || undefined
  }
  if (begin && end) params = Object.assign({}, params, { beginTime: begin, endTime: end })
  emit('on-change', params)
}

// Initialization
sendEvent()
</script>
